import { ArrowRight } from '@phosphor-icons/react';
import { CTA_LABEL, SITE } from '../data/site';
import Container from './ui/Container';
import LinkButton from './ui/Button';
import Reveal from './ui/Reveal';

function CtaBand() {
  return (
    <section className="pb-20 pt-6 sm:pb-28 sm:pt-10">
      <Container>
        <Reveal>
          <div className="bg-brand-gradient relative overflow-hidden rounded-5xl px-6 py-14 text-white sm:px-12 sm:py-16 lg:px-16 lg:py-20">
            <img
              src="/main_logo.png"
              alt=""
              aria-hidden="true"
              className="pointer-events-none absolute -bottom-20 -right-12 w-[300px] rotate-[-14deg] opacity-25 sm:w-[420px]"
            />
            <div className="relative grid gap-8 lg:grid-cols-[1fr_auto] lg:items-center">
              <div>
                <h2 className="text-balance text-[1.9rem] font-bold leading-[1.5] tracking-[-0.025em] sm:text-4xl lg:text-[2.9rem]">
                  지금 필요한 웹서비스가 있다면
                  <br />
                  이야기해 주세요
                </h2>
                <p className="mt-4 max-w-xl text-base leading-[1.75] text-white/85 sm:text-lg">
                  범위가 정해지지 않았어도 괜찮습니다. 상담에서 함께 정리하고, 이메일이나 카카오톡으로 답변드립니다.
                </p>
              </div>
              <div className="flex flex-col gap-3 sm:flex-row lg:flex-col lg:items-stretch">
                <LinkButton to="/contact" variant="inverse" size="lg">
                  {CTA_LABEL}
                  <ArrowRight size={18} weight="bold" className="transition-transform duration-300 group-hover:translate-x-0.5" />
                </LinkButton>
                <a
                  href={SITE.kakao}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex h-12 items-center justify-center rounded-full border border-white/40 px-6 text-base font-semibold text-white transition-colors hover:bg-white/15 sm:h-[52px] sm:px-7"
                >
                  카카오톡 오픈채팅
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </Container>
    </section>
  );
}

export default CtaBand;
